import { ChargepointConnectorModel } from "src/app/models/chargepoint/chargepoint-connector";
import { ChargePointModel } from "src/app/models/chargepoint/chargepoint-vnf";
import { LocationModel } from "src/app/models/location/location";
import { ChargePoint, ChargePointConnector, Location } from "src/swagger-gen/vnf-secured/models";

export class StationRepoModelMapper {

    static toChargePointModel(r: ChargePoint): ChargePointModel {
        return {
            uid: r.uid ?? '',
            state: r.state ?? null,
            code: r.code ?? null,
            name: r.name ?? null,
            chargePointId: r.chargePointId ?? null,
            connectors: StationRepoModelMapper.toChargepointConnectorModelList(r.connectors ?? []),
            location: r.location ? StationRepoModelMapper.toLocation(r.location) : null,
            position: r.position ?? null
        }
    }

    static toChargePointModelList(r: ChargePoint[]): ChargePointModel[] {
        return r.map(res => StationRepoModelMapper.toChargePointModel(res));
    }

    static toChargepointConnectorModel(r: ChargePointConnector): ChargepointConnectorModel {
        return {
            uid: r.uid ?? null,
            chargeType: r.chargeType ?? null,
            connectedAuthSupportUid: r.connectedAuthSupportUid ?? null,
            connectorId: r.connectorId ?? null,
            position: r.position ?? null,
            realtimeState: r.realtimeState ?? null,
            type: r.type ?? null,
            maxCurrent: r.maxCurrent ?? null
        }
    }

    static toChargepointConnectorModelList(r: ChargePointConnector[]): ChargepointConnectorModel[] {
        return r.map(res => StationRepoModelMapper.toChargepointConnectorModel(res));
    }

    static toLocation(r: Location): LocationModel {
        return {
            latitude: r.latitude ?? null,
            longitude: r.longitude ?? null
        }
    }
}